import { render, staticRenderFns } from "./ModifyPassPage.vue?vue&type=template&id=1442350c&scoped=true"
import script from "./ModifyPassPage.vue?vue&type=script&lang=js"
export * from "./ModifyPassPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1442350c",
  null
  
)

export default component.exports